import { render, staticRenderFns } from "./BulkOperations.vue?vue&type=template&id=00730d00&scoped=true&"
import script from "./BulkOperations.vue?vue&type=script&lang=js&"
export * from "./BulkOperations.vue?vue&type=script&lang=js&"
import style0 from "./BulkOperations.vue?vue&type=style&index=0&id=00730d00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00730d00",
  null
  
)

export default component.exports